import React from 'react';
import './styles/Horizontal.css';

const HorizontalScroll = ({ image, title, id }) => {
    let idString = id.toString();
    return (
        <div className="scroll__parent">
            <a href={`/product?id=${idString}`} className="item__link">
                <img className="item" src={image} alt="" />
                <div className="overlay">{title}</div>
            </a>
        </div>
    );
};

export default HorizontalScroll;